import { render, staticRenderFns } from "./InstanceEditGeneral.vue?vue&type=template&id=208d3ba3&scoped=true&"
import script from "./InstanceEditGeneral.vue?vue&type=script&lang=js&"
export * from "./InstanceEditGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d3ba3",
  null
  
)

export default component.exports